var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.2C8.75 2.53726 8.66272 2 8 2C7.33728 2 7.25 2.83726 7.25 3.5V7.25H3.125C2.46226 7.25 2 7.33728 2 8C2 8.66272 2.53726 8.75 3.2 8.75H7.25V12.8C7.25 13.4627 7.33728 14 8 14C8.66272 14 8.75 13.4627 8.75 12.8V8.75H12.8C13.4627 8.75 14 8.66272 14 8C14 7.33728 13.4627 7.25 12.8 7.25H8.75V3.2Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.a987c71c32b3512484971605cb715de7.svg";
export { ForwardRef as ReactComponent };